export default {
  '场所':'場所',
  '批量解绑':'批量解綁',
  '已选中{selectedCount}人':'已選中{selectedCount}人',
  '取消全部选中':'取消全部選中',
  '解绑':'解綁',
  '设备名、序列号模糊搜索':'設備名、序列號模糊搜索',
  '机构名称':'機構名稱',
  '机构代码':'機構代碼',
  '设备名称':'設備名稱',
  '序列号':'序列號',
  'MAC地址':'MAC地址',
  '场所名称':'場所名稱',
  '激活时间':'激活時間',
  '设备状态':'設備狀態',
  '是否确认批量解绑{selectedCount}个设备？':'是否確認批量解綁{selectedCount}個設備？',
  '是否确认解绑设备{deviceName}？':'是否確認解綁設備{deviceName}？',
  '解绑成功！':'解綁成功！',
  '软件版本':'軟體版本',
  '子设备':'子設備',
  '当前版本':'當前版本',
  '子设备列表':'子設備清單',
  '子设备名称':'子設備名稱',
  '序列号':'序號',
  'MAC 地址':'MAC 地址',
  '激活时间':'啟動時間',
  '应用及版本':'應用及版本',
  '设备详情':'設備詳情',
  '设备信息':'設備資訊',
  '应用信息':'應用程式資訊',
  '专注模式':'專注模式',
  '设置专注模式':'設置專注模式',
  '专注时间':'專注計時',
  '确定关闭本设备的专注模式吗？':'​確定要關閉本設備的專注模式嗎？​',
}    